import { useState, useEffect, useCallback } from 'react';
import { insumoService } from '../services/supabase';

export function useInsumos(usuarioId, campoId) {
  const [insumos, setInsumos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const loadInsumos = useCallback(async () => {
    if (!usuarioId || !campoId) return;
    setLoading(true);
    setError(null);
    try {
      const data = await insumoService.getAll(usuarioId, campoId);
      setInsumos(data || []);
    } catch (e) {
      setError(e.message);
      console.error('Error cargando insumos:', e);
    } finally {
      setLoading(false);
    }
  }, [usuarioId, campoId]);

  useEffect(() => {
    loadInsumos();
  }, [loadInsumos]);

  const createInsumo = useCallback(async (insumo) => {
    if (!usuarioId || !campoId) throw new Error("usuarioId y campoId requeridos");
    try {
      const saved = await insumoService.create(usuarioId, campoId, insumo);
      setInsumos(prev => [...prev, saved]);
      return saved;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, [usuarioId, campoId]);

  const updateInsumo = useCallback(async (insumoId, updates) => {
    try {
      const updated = await insumoService.update(insumoId, updates);
      setInsumos(prev => prev.map(i => i.id === insumoId ? updated : i));
      return updated;
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  const deleteInsumo = useCallback(async (insumoId) => {
    try {
      await insumoService.delete(insumoId);
      setInsumos(prev => prev.filter(i => i.id !== insumoId));
    } catch (e) {
      setError(e.message);
      throw e;
    }
  }, []);

  return {
    insumos,
    setInsumos,
    loading,
    error,
    loadInsumos,
    createInsumo,
    updateInsumo,
    deleteInsumo,
  };
}
